import classNames from 'classnames';
import React from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EfImg from '../ef-img';
import './index.scss';

export interface EfSwiperOnlyH5ItemProps {
    /**
     * 图片
     */
    pc: string;
    /**
     * 图片
     */
    pad?: string;
    /**
     * 图片
     */
    h5: string;
    /**
     * 跳转链接
     */
    section?: React.ReactNode;
}
interface EfSwiperOnlyH5Props {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    items?: EfSwiperOnlyH5ItemProps[];
    /**
     * loop
     */
    loop?: boolean;
}

/**
 * 维护:谢保林
 *
 * 左右划动卡片
 */
const EfSwiperOnlyH5: React.FC<EfSwiperOnlyH5Props> = ({ items = [], className, loop }) => {
    const prefixCls = `ef-swiper-only-h5`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
    });

    return (
        <div className={classes}>
            <div className={`${prefixCls}-pc`}>
                {items?.map((item: EfSwiperOnlyH5ItemProps, k: number) => (
                    <div className={`${prefixCls}-pc-item ${prefixCls}-pc-item-${1 + k}`} key={k}>
                        <EfImg pc={item.pc} />
                        {item.section && <div className={`${prefixCls}-pc-item-section`}>{item.section}</div>}
                    </div>
                ))}
            </div>
            <div className={`${prefixCls}-h5`}>
                <Swiper
                    className={`${prefixCls}-list`}
                    modules={[Navigation, Pagination]}
                    loop={String(loop) ? loop : items?.length > 1}
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    navigation={true}
                    pagination={true}
                >
                    {items?.map((item: EfSwiperOnlyH5ItemProps, k: number) => (
                        <SwiperSlide className={`${prefixCls}-h5-item`} key={k}>
                            <div className={`${prefixCls}-h5-item ${prefixCls}-pc-item-${1 + k}`} key={k}>
                                <EfImg pc={item.pc} pad={item.pad} h5={item.h5} />
                                {item.section && <div className={`${prefixCls}-h5-item-section`}>{item.section}</div>}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default EfSwiperOnlyH5;
